import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    claim: {}
  },
  mutations: {
    setClaim(state, claim) {
      state.claim = claim;
    }
  },
  actions: {},
  getters: {
    layout: () => "admin",
    claim: state => state.claim,
    screenName: state =>
      state.claim.screen_name ? state.claim.screen_name : ""
  }
});
